export enum FifScript {
  DFL = 'DFL',
  QRS = 'QRS',
  IUL = 'IUL',
  IBC = 'IBC',
  Annuity = 'Annuity',
}
